import searchBox from '../../common/search-box/search-box';
import basketWebitem from './HEA01-header-basket/basket-webitem/basket-webitem.vue';
import Multiselect from 'vue-multiselect';
import vClickOutside from 'v-click-outside';
import {respoBreakPoints} from '../../common/common';
import {
	mapState,
	mapActions,
	mapGetters
} from 'vuex';

import {
	BASKET_ITEM_TYPES
} from './../../common/constants/constants';
import eventBus from '../../common/event-bus/event-bus';
import getAddressLabel from '../../common/utils/get-address-label';

const BUSINESS_URL = '/uzleti';
export default {
	directives: {
		clickOutside: vClickOutside.directive
	},
	data() {
		return {
			activeSegmentUrl: null,
			showHeaderSearch: false,
			showMegamenu: null,
			showHeaderMainmenu: false,
			showHamburgerMenu: false,
			suggestions: [], // searchbox miatt
			segment: null,
			cartsClickOutsideConfig: null
		};
	},
	components: {
		'search-box': searchBox,
		basketWebitem,
		Multiselect
	},
	computed: {
		...mapState('headerStore', ['hideHeaderSearchMenu']),
		...mapState('cartsStore', ['isCartsShown']),
		...mapGetters('cartsStore', ['numberOfItemsInCarts', 'notEmptyCarts']),

		BASKET_ITEM_TYPES() {
			return BASKET_ITEM_TYPES;
		}
	},
	methods: {
		...mapActions('cartsStore', ['openCarts', 'closeCarts', 'addToCart']),
		toggleHeaderSearch() {
			let previousHeaderSearch = this.showHeaderSearch;
			this.closeMenus();
			this.showHeaderSearch = !previousHeaderSearch;
			if (this.showHeaderSearch) {
				setTimeout(() => {
					this.$refs.searchBox.$refs.searchInput.focus();
				}, 600);
			}
		},
		toggleCarts() {
			if (this.numberOfItemsInCarts && !this.isCartsShown) {
				this.openCarts();
			} else if (this.isCartsShown) {
				this.closeCarts();
			}
		},
		toggleMegamenu(index) {
			if (this.$mq.below(respoBreakPoints.tablet)) {
				let previousMegamenu = this.showMegamenu;
				this.showMegamenu = previousMegamenu === index ? null : index;
			} else {
				let previousMegamenu = this.showMegamenu;
				this.closeMenus();
				this.showMegamenu = previousMegamenu === index ? null : index;
			}
		},
		toggleHeaderMainmenu() {
			if (this.$mq.above(respoBreakPoints.tablet) && this.$mq.below(respoBreakPoints.desktop)) {
				let previousHeaderMainMenu = this.showHeaderMainmenu;
				this.closeMenus();
				this.showHeaderMainmenu = !previousHeaderMainMenu;
			}
		},
		toggleHamburgerMenu() {
			let previousHamburgerMenu = this.showHamburgerMenu;
			this.closeMenus();
			this.showHamburgerMenu = !previousHamburgerMenu;
		},
		closeMenus() {
			this.showHeaderSearch = false;
			this.closeCarts();
			this.showMegamenu = null;
			this.showHeaderMainmenu = false;
			this.showHamburgerMenu = false;
		},
		goToUrl(option) {
			window.location.href = option.url;
		},
		getLabelForAddress(address) {
			return getAddressLabel(address);
		},
		search() {},
		autoSuggest() {} // search-box miatt
	},
	mounted() {
		const currentUrl = window.location.pathname;
		const segments = currentUrl.split('/');
		this.activeSegmentUrl = '/' + segments[1];

		eventBus.$on('on-add-to-cart', this.addToCart);

		// https://jira.shiwaforce.com/browse/TARR2558-275
		// mobilon a réteg valamiért elkapja a kérést és bezárja, viszont a gombnyomás tovább megy és a gomb is triggerelődik, ezt gátolja meg
		this.cartsClickOutsideConfig = {
			handler: this.closeCarts,
			middleware: event => !event.target.closest('[data-cart-toggle-button=""]'),
			capture: true
		};
	}
};



// WEBPACK FOOTER //
// ../source/modules/HEA01-header/HEA01-header.js